import { render, staticRenderFns } from "./CampaignSetupMarketingInformation.vue?vue&type=template&id=05e942c4&"
import script from "./CampaignSetupMarketingInformation.vue?vue&type=script&lang=js&"
export * from "./CampaignSetupMarketingInformation.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSetupMarketingInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports